import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PagingInfo} from "src/app/shared";
import { FvmsApiBaseService } from "./fvms.api.base.service";

//Deprecated
@Injectable({providedIn: 'root'})
export class FvmsApiDtgReportUserService extends FvmsApiBaseService {
    constructor(
        public http:HttpClient
    ) {
        super(http);
    }

    // getListReportUser(searchInfo:any,pagingInfo:PagingInfo):Observable<any>{
    //     let url = this.getApiBaseUrl() + "/dtg/report/user";
    //     url += "/list";

    //     let header = new HttpHeaders({
    //         "Content-Type":"application/json"
    //     });

    //     let tmpPostObject = {
    //         "searchInfo":searchInfo
    //         ,"pagingInfo":pagingInfo
    //     };

    //     //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
    //     //때문에 객체를 복사해서 사용
    //     let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

    //     let bodyData = JSON.stringify(tmpData);

    //     return this.http.post<any>(url,bodyData,{ headers : header });
    // }


    // getSumReportUser(searchInfo:any):Observable<any>{
    //     let url = this.getApiBaseUrl() + "/dtg/report/user";
    //     url += "/sum";

    //     let header = new HttpHeaders({
    //         "Content-Type":"application/json"
    //     });

    //     let tmpPostObject = {
    //         "searchInfo":searchInfo
    //         ,"pagingInfo":null
    //     };

    //     //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
    //     //때문에 객체를 복사해서 사용
    //     let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

    //     let bodyData = JSON.stringify(tmpData);

    //     return this.http.post<any>(url,bodyData,{ headers : header });
    // }

    // getListReportUserPersonalTrip(searchInfo:any,pagingInfo:PagingInfo):Observable<any>{
    //     let url = this.getApiBaseUrl() + "/dtg/report/user";
    //     url += "/personal/trip/list";

    //     let header = new HttpHeaders({
    //         "Content-Type":"application/json"
    //     });

    //     let tmpPostObject = {
    //         "searchInfo":searchInfo
    //         ,"pagingInfo":pagingInfo
    //     };

    //     //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
    //     //때문에 객체를 복사해서 사용
    //     let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

    //     let bodyData = JSON.stringify(tmpData);

    //     return this.http.post<any>(url,bodyData,{ headers : header });
    // }

    // getListReportUserPersonalTripSum(searchInfo:any):Observable<any>{
    //     let url = this.getApiBaseUrl() + "/dtg/report/user";
    //     url += "/personal/trip/summary";

    //     let header = new HttpHeaders({
    //         "Content-Type":"application/json"
    //     });

    //     let tmpPostObject = {
    //         "searchInfo":searchInfo
    //         ,"pagingInfo":null
    //     };

    //     //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
    //     //때문에 객체를 복사해서 사용
    //     let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

    //     let bodyData = JSON.stringify(tmpData);

    //     return this.http.post<any>(url,bodyData,{ headers : header });
    // }

    // getListReportUserDetailTripSum(searchInfo:any):Observable<any>{
    //     let url = this.getApiBaseUrl() + "/dtg/report/car";
    //     url += "/detail/trip/summary";

    //     let header = new HttpHeaders({
    //         "Content-Type":"application/json"
    //     });

    //     let tmpPostObject = {
    //         "searchInfo":searchInfo
    //     };

    //     //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
    //     //때문에 객체를 복사해서 사용
    //     let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

    //     let bodyData = JSON.stringify(tmpData);

    //     return this.http.post<any>(url,bodyData,{ headers : header });
    // }

    // getDailyListbyLcsNo(searchInfo:any):Observable<any>{
    //     let url = this.getApiBaseUrl() + "/dtg/report/user";
    //     url += "/personal/daily/listByLcsNo";

    //     let header = new HttpHeaders({
    //         "Content-Type":"application/json"
    //     });

    //     let tmpPostObject = {
    //         "searchInfo":searchInfo
    //     };

    //     //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
    //     //때문에 객체를 복사해서 사용
    //     let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

    //     let bodyData = JSON.stringify(tmpData);

    //     return this.http.post<any>(url,bodyData,{ headers : header });
    // }

    // getTripListbyLcsNo(searchInfo:any,pagingInfo:PagingInfo):Observable<any>{
    //     let url = this.getApiBaseUrl() + "/dtg/report/user";
    //     url += "/personal/trip/listByLcsNo";

    //     let header = new HttpHeaders({
    //         "Content-Type":"application/json"
    //     });

    //     let tmpPostObject = {
    //         "searchInfo":searchInfo
    //         ,"pagingInfo":pagingInfo
    //     };

    //     //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
    //     //때문에 객체를 복사해서 사용
    //     let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

    //     let bodyData = JSON.stringify(tmpData);

    //     return this.http.post<any>(url,bodyData,{ headers : header });
    // }

    // getTripListSumDataByLcsNo(searchInfo:any,pagingInfo:PagingInfo):Observable<any>{
    //     let url = this.getApiBaseUrl() + "/dtg/report/user";
    //     url += "/personal/trip/selectTripListSumDataByLcsNo";

    //     let header = new HttpHeaders({
    //         "Content-Type":"application/json"
    //     });

    //     let tmpPostObject = {
    //         "searchInfo":searchInfo
    //         ,"pagingInfo":pagingInfo
    //     };

    //     //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
    //     //때문에 객체를 복사해서 사용
    //     let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

    //     let bodyData = JSON.stringify(tmpData);

    //     return this.http.post<any>(url,bodyData,{ headers : header });
    // }

    // getDangerDrivingListByTrip(searchInfo:any,pagingInfo:PagingInfo):Observable<any>{
    //     let url = this.getApiBaseUrl() + "/dtg/report/user";
    //     url += "/personal/trip/selectDangerDrivingListByTrip";

    //     let header = new HttpHeaders({
    //         "Content-Type":"application/json"
    //     });

    //     let tmpPostObject = {
    //         "searchInfo":searchInfo
    //         ,"pagingInfo":pagingInfo
    //     };

    //     //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
    //     //때문에 객체를 복사해서 사용
    //     let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

    //     let bodyData = JSON.stringify(tmpData);

    //     return this.http.post<any>(url,bodyData,{ headers : header });
    // }




}